<template>
  <main-layout
    class="editFarming"
    page-title="编辑农事"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="editFarming-content">
      <!-- 农事类型-施肥、用药、翻耕、灌溉 -->
      <agric-operations
        v-if="type == 2 || type == 3 || type == 6 || type == 7"
        :isBack="isBack"
        @updateStatus="(val) => (isBack = val)"
      ></agric-operations>
      <!-- 农事类型-采收 -->
      <recovery-form
        v-if="type == 4"
        :isBack="isBack"
        @updateStatus="(val) => (isBack = val)"
      ></recovery-form>
      <!-- 农事类型-播种、移栽 -->
      <seeding-form
        v-if="type == 1 || type == 8"
        :isBack="isBack"
        @updateStatus="(val) => (isBack = val)"
      ></seeding-form>
      <!-- 农事类型sales-销售 -->
      <sales-form
        v-if="type == 5"
        :isBack="isBack"
        @updateStatus="(val) => (isBack = val)"
      ></sales-form>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import AgricOperations from "./AgricOperations";
import RecoveryForm from "./RecoveryForm";
import SeedingForm from "./SeedingForm";
import SalesForm from "./SalesForm";

export default {
  name: "EditFarming",
  components: {
    MainLayout,
    AgricOperations,
    RecoveryForm,
    SeedingForm,
    SalesForm,
  },
  data() {
    return {
      type: 1, //1:播种、2：施肥、3：用药、4：采收、5：销售
      isBack: false,
    };
  },
  created() {
    this.type = this.$route.query.type * 1;
  },
  methods: {
    goBack() {
      this.isBack = true;
      // this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="scss">
.editFarming {
  .editFarming-content {
    width: 1200px;
    height: 100%;
    background: #fff;
    margin: 0 auto;
    ::v-deep .el-form-item__content {
      padding-left: 20px;
      .el-form-item__error {
        left: 20px;
      }
    }
  }
}
</style>
